import { useState, useEffect } from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Dialog,
  Typography,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import {
  TrashIcon,
  PlusIcon,
  PenIcon
} from "../../components/svgicons/SvgIcons";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import FancyTooltip from "../../components/utils/FancyTooltip";
import FancyPaper from "../../components/FancyPaper";
import { useForm } from "react-hook-form";
import DeleteModal from "../../components/utils/DeleteModal";
import ResourceAccess from "../../components/security/ResourceAccess";
import FancyTablePagination from "../../components/utils/FancyTablePagination";
import { useApp } from "../../hooks/useApp";
import AddOrUpdateInventory from "../../components/utils/AddOrUpdateInventory";
import FancyDialogActions from "../../components/utils/FancyDialogActions";
import { properties } from "../../utils/Properties_es";
import {
  createRequest,
  deleteRequest,
  getRequestProductsInventory,
  updateRequest,
  getRequestListFamily,
  getRequestListSubFamily,
  getRequestListSubSubFamily,
  getRequestWarehouse,
  getRequestTotal,
} from "../../services/inventory/InventoryService";
import {getRequestMeasureUnit} from "../../services/unit/UnitService";
import FancySearch from "../../components/utils/FancySearch";
import { uploadDocuments } from "../../services/documents/DocumentService";
import dayjs from "dayjs";

const ManagementInventory = () => {
  const {
    authInfo,
    setLoading,
    setErrorMsg,
    modalData,
    setModalData,
    setSuccessMsg,
    errorMsg,
  } = useApp();
  const [inventoryData, setInventoryData] = useState<any>([]);
  const [FamilyData, setFamilyData] = useState<any>([]);
  const [WarehouseData, setWarehouseData] = useState<any>([]);
  const [measureData, setMeasureData] = useState<any>([]);
  const [TotalPrice, setTotalPrice] = useState<any>([]);
  const [PriceSelected, setPriceSelected] = useState<number>(0);
  const [preFilter, setPreFilter] = useState<any>("");
  const [formData, setFormData] = useState<any>("");
  const [page, setPage] = useState(0);
  const { handleSubmit } = useForm();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [warehouseFilter, setWarehouseFilter] = useState<string>("");
  const [quantityFilter, setQuantityFilter] = useState<number | null>(null);
  const [quantityOperator, setQuantityOperator] = useState<any>("");
  const [showFilters, setShowFilters] = useState(false);

  const operatorOptions = [
    { value: "eq", label: "Igual a" },
    { value: "gt", label: "Mayor que" },
    { value: "lt", label: "Menor que" },
    { value: "ne", label: "No igual a" },
    { value: "ge", label: "Mayor o igual que" },
    { value: "le", label: "Menor o igual que" },
  ];


  const initForm = {
    user: "",
    id: 0,
    code: "",
    officialCode: "",
    serialCode: "",
    description: "",
    acquisitionDate: dayjs().format("YYYY-MM-DD"),
    availability: true,
    availableQuantity: 0,
    quantity: 0,
    brand: "",
    category: "",
    color: "",
    cost: 0,
    status: 0,
    warehouseLocation: "",
    notes: "",
    subSubFamily: {
      id: 0,
      name: "",
      code: "",
      description: "",
      subFamily: {
        id: 0,
        name: "",
        code: "",
        description: "",
        family: {
          id: 0,
          name: "",
          code: "",
          description: "",
        },
      },
    },
  };

  useEffect(() => {
    const dataInit = async () => {
      await handleFetchData(0, "");
      let Familydata = await getRequestListFamily("", 0, "200");
      setFamilyData(Familydata);
      let WherehouseList = await getRequestWarehouse();
      setWarehouseData(WherehouseList);
      let TotalPrice = await getRequestTotal();
      setTotalPrice(TotalPrice);
      let MeasureUnitData = await getRequestMeasureUnit();
      setMeasureData(MeasureUnitData);
    };
    dataInit();
    // eslint-disable-next-line
  }, [warehouseFilter, statusFilter, quantityFilter, quantityOperator]);

  const formatQuantityFilter = (operator: string, filter: number | null): string => {
    if (filter === null) return ""; // Si no hay filtro, devolver un string vacío
    return `${operator}${filter}`;
  };

  const handleFetchData = async (currentPage: number, filter: string) => {
    setLoading && setLoading(true);
    setPage(currentPage);

    // Formatear el filtro de cantidad
    const formattedQuantityFilter = formatQuantityFilter(quantityOperator, quantityFilter);

    try {
      let data = await getRequestProductsInventory(
        currentPage,
        showFilters ? "" : filter,
        10,
        warehouseFilter,
        showFilters ? filter : "",
        statusFilter,
        formattedQuantityFilter
      );

      if (data) {
        setInventoryData(data);
      }

      let TotalPrice = await getRequestTotal();
      
      setTotalPrice(TotalPrice);

      setLoading && setLoading(false);
    } catch (error: any) {
      setLoading && setLoading(false);
      setErrorMsg && setErrorMsg(error.message);
    }
  };

  const handleFetchSubFamilyData = async (
    id: number,
    setSubfamily: React.Dispatch<React.SetStateAction<any[]>>
  ) => {
    try {
      let SubFamilydata = await getRequestListSubFamily(id, "", 0, "500");
      if (SubFamilydata && "content" in SubFamilydata) {
        setSubfamily(SubFamilydata.content as any[]);
      } else {
        setSubfamily([]);
      }
      setLoading && setLoading(false);
    } catch (error: any) {
      setLoading && setLoading(false);
      setErrorMsg && setErrorMsg(error.message);
    }
  };

  const handleFetchSubSubFamilyData = async (
    id: number,
    setSubSubfamily: React.Dispatch<React.SetStateAction<any[]>>
  ) => {
    try {
      let SubSubFamilydata = await getRequestListSubSubFamily(id, "", 0, "500");
      if (SubSubFamilydata && "content" in SubSubFamilydata) {
        setSubSubfamily(SubSubFamilydata.content as any[]);
      } else {
        setSubSubfamily([]);
      }
      setLoading && setLoading(false);
    } catch (error: any) {
      setLoading && setLoading(false);
      setErrorMsg && setErrorMsg(error.message);
    }
  };

  const handleAdd = async (data: any) => {
    console.log("handleAdd: ", data);
    handleCancelModal();
    setLoading && setLoading(true);
    try {
      let createData: any = await createRequest({
        ...data,
        user: authInfo?.username,
      });

      if (!createData) {
        setErrorMsg &&
          setErrorMsg(properties.com_parval_label_inventory_create_error);
        setLoading && setLoading(false);
        return;
      }

      const idProduct = createData.id;

      if (!!data.inventoryImage.length) {
        const formData = new FormData();
        formData.append("productId", idProduct);
        for (let i = 0; i < data.inventoryImage.length; i++) {
          formData.append("file", data.inventoryImage[i]);
        }
        formData.append("user", authInfo.username);
        await uploadDocuments(formData);
      }
      setLoading && setLoading(false);
      setSuccessMsg &&
        setSuccessMsg(properties.com_parval_label_inventory_create);
      await handleFetchData(0, "");
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  };

  const handleUpdate = async (data: any) => {
    handleCancelModal();
    setLoading && setLoading(true);
    try {
      let updateData = await updateRequest({
        ...data,
        user: authInfo?.username,
      });

      if (!updateData) {
        setErrorMsg &&
          setErrorMsg(properties.com_parval_label_inventory_update_error);
        setLoading && setLoading(false);
        return;
      }
      setLoading && setLoading(false);
      setSuccessMsg &&
        setSuccessMsg(properties.com_parval_label_inventory_update);

      await handleFetchData(page, preFilter);
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    handleCancelModal();
    setLoading && setLoading(true);
    try {
      let deleteData: any = await deleteRequest(id);
      if (!deleteData) {
        setErrorMsg &&
          setErrorMsg(properties.com_parval_label_inventory_delete_error);
        setLoading && setLoading(false);
        return;
      }
      setLoading && setLoading(false);
      setSuccessMsg &&
        setSuccessMsg(properties.com_parval_label_inventory_delete);
      setPage(0);
      await handleFetchData(0, "");
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  };

  /**
   * Efecto para validar errores en caso de abrir modal
   */
  useEffect(() => {
    if (modalData && modalData?.modalOpen && errorMsg) {
      setModalData &&
        setModalData({
          modalOpen: false,
          modalType: "",
          modalObject: null,
        });
    }
  }, [modalData, errorMsg, setModalData]);

  /**
   * Evento de apertura de modal
   */
  const handleOpenModal = async (event: any) => {
    event.preventDefault();
    const modalAction = event.currentTarget.getAttribute("data-name");
    let object = null;
    const id = event.currentTarget.getAttribute("data-id");

    if (modalAction === "update") {
      object = inventoryData.content.find((p: any) => p.id === parseInt(id));
    }

    if (modalAction === "delete") {
      object = inventoryData.content.find((p: any) => p.id === parseInt(id));
    }

    //open modal
    setModalData &&
      setModalData({
        ...modalData,
        modalOpen: true,
        modalType: modalAction,
        modalObject: object,
      });
  };

  /*   const handleFetchByID = async (id: number) => {
    setLoading && setLoading(true);
    try {
      // let userData = await findByIdRequest(id);
      // if (userData) {
      //   //@ts-ignore
      //   setFormData(userData.content);
      // }
      setLoading && setLoading(false);
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  }; */

  /**
   * Evento de aplicar filtro de busqueda
   */
  const handleApplyFilter = async () => {
    await handleFetchData(0, preFilter);
  };

  /**
   * Evento de cierre de modal
   * @param event
   */
  const handleCancelModal = () => {
    //@ts-ignore
    if (modalData?.modalType !== "delete") {
      setFormData(initForm);
    }
    setModalData &&
      setModalData({
        ...modalData,
        modalOpen: false,
        modalType: "",
        modalObject: null,
      });
  };

  const handleChangePage = async (event: unknown, newPage: number) => {
    setPage(newPage - 1);
    let customPage = newPage - 1;
    if (customPage !== page) {
      await handleFetchData(customPage, preFilter);
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPage(0);
  };

  const onSubmit = async (data: any) => {
    data.acquisitionDate = dayjs(data.acquisitionDate).format("YYYY-MM-DD");
    switch (modalData?.modalType) {
      case "create":
        await handleAdd(data);
        break;
      case "update":
        await handleUpdate(data);
        break;
      case "delete":
        //@ts-ignore
        await handleDelete(modalData?.modalObject.id);
        break;
      default:
        break;
    }
    if (modalData?.modalType !== "delete") {
      setFormData(formData);
    }
  };

  const handleCheckboxChange = (isChecked: boolean, cost: number) => {
    setPriceSelected((prev) => (isChecked ? prev + cost : prev - cost));
  };

  const formatNumber = (value: number): string => {
    return new Intl.NumberFormat("es-ES", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  return (
    <>
      <FancyPaper pagetitle="Inventario">
        <Grid container spacing={8} sx={{ pb: 8, alignItems: "center" }}>
          <Grid item lg={7} md={7} sm={5} xs={12}>
            <ResourceAccess isCode={true} pathOrCode={"INVENTORY:WRITE"}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenModal}
                data-name="create"
              >
                Agregar producto
                <PlusIcon sx={{ ml: 1 }} />
              </Button>
            </ResourceAccess>
          </Grid>
          <Grid item lg={5} md={5} sm={7} xs={12}>
            <FancySearch
              preFilter={preFilter}
              setPreFilter={setPreFilter}
              handleFetchData={() => handleFetchData(0, "")}
              handleApplyFilter={handleApplyFilter}

              // New inventory filter props
              showInventoryFilters={showFilters}
              warehouseData={WarehouseData}
              warehouseFilter={warehouseFilter}
              setWarehouseFilter={(newValue) => setWarehouseFilter(newValue)}
              statusFilter={statusFilter}
              setStatusFilter={(newValue) => setStatusFilter(newValue)}
              quantityFilter={quantityFilter}
              setQuantityFilter={(newValue) => setQuantityFilter(newValue)}
              quantityOperator={quantityOperator}
              setQuantityOperator={(newValue) => setQuantityOperator(newValue)}
              operatorOptions={operatorOptions}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="primary"
              onClick={() => setShowFilters(!showFilters)}
              startIcon={showFilters ? <RemoveIcon /> : <AddIcon />}
            >
              {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
            </Button>
          </Grid>
        </Grid>
        <TableContainer>
          <Table
            sx={{ minWidth: 650, textAlign: "center" }}
            aria-label="inventory table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell align="center">Descripción</TableCell>
                <TableCell align="center">Cantidad Disponible</TableCell>
                <TableCell align="center">Disponibilidad</TableCell>
                <ResourceAccess isCode={true} pathOrCode={"INVENTORY:WRITE"}>
                  <TableCell align="center">Acciones</TableCell>
                </ResourceAccess>
              </TableRow>
            </TableHead>
            <TableBody>
              {inventoryData?.content?.length > 0 ? (
                inventoryData?.content?.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell>{`${row.code}`}</TableCell>
                    <TableCell align="center">{row.description}</TableCell>
                    <TableCell align="center">
                      {row.availableQuantity}
                    </TableCell>
                    <TableCell align="center">
                      {row.availability === true ? "Disponible" : "En proyecto"}
                    </TableCell>

                    <TableCell align="center">
                      <ResourceAccess
                        isCode={true}
                        pathOrCode={"INVENTORY:WRITE"}
                      >
                        <Checkbox
                          color="primary"
                          onChange={(event) =>
                            handleCheckboxChange(
                              event.target.checked,
                              row.cost * row.quantity
                            )
                          }
                        />
                        <FancyTooltip title="Editar" placement="top">
                          <IconButton
                            aria-label="edit"
                            component="label"
                            color="primary"
                            onClick={handleOpenModal}
                            data-name="update"
                            data-id={row.id}
                          >
                            <PenIcon />
                          </IconButton>
                        </FancyTooltip>
                        <FancyTooltip title="Eliminar" placement="top">
                          <IconButton
                            aria-label="trash"
                            component="label"
                            color="error"
                            data-id={row.id}
                            onClick={handleOpenModal}
                            data-name="delete"
                          >
                            <TrashIcon />
                          </IconButton>
                        </FancyTooltip>
                      </ResourceAccess>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5}>No existen registros</TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  align="center"
                  colSpan={2}
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#000606",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "1rem",
                    borderRadius: "25rem",
                  }}
                >
                  <Typography variant="h6">Precio Total</Typography>
                </TableCell>

                <TableCell></TableCell>

                <TableCell
                  align="center"
                  colSpan={2}
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#000606",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "1rem",
                    borderRadius: "25rem",
                  }}
                >
                  <Typography variant="h6">Precio Seleccionado</Typography>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  align="center"
                  colSpan={2}
                  style={{
                    padding: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "25rem",
                  }}
                >
                  <Typography variant="h6">
                    ₡{formatNumber(TotalPrice)}
                  </Typography>
                </TableCell>

                <TableCell></TableCell>

                <TableCell
                  align="center"
                  colSpan={2}
                  style={{
                    padding: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "25rem",
                  }}
                >
                  <Typography variant="h6">
                    ₡{formatNumber(PriceSelected)}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <FancyTablePagination
          count={
            inventoryData?.content?.length > 0
              ? inventoryData?.content?.length
              : 0
          }
          rowsPerPage={inventoryData.size}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalElements={inventoryData.totalElements}
          totalPages={inventoryData.totalPages}
        />
      </FancyPaper>
      {(modalData?.modalType === "create" ||
        modalData?.modalType === "update") && (
          <Dialog
            open={modalData.modalOpen}
            onClose={handleCancelModal}
            maxWidth="md"
            fullWidth
          >
            <AddOrUpdateInventory
              data={modalData?.modalObject}
              FamilyData={FamilyData}
              WarehouseData={WarehouseData}
              measureData={measureData}
              handleFetchSubFamilyData={handleFetchSubFamilyData}
              handleFetchSubSubFamilyData={handleFetchSubSubFamilyData}
              onSubmit={onSubmit}
              cancelModal={handleCancelModal}
              modalType={modalData?.modalType}
            />
          </Dialog>
        )}
      {modalData?.modalType === "delete" && (
        <Dialog
          open={modalData.modalOpen}
          onClose={handleCancelModal}
          fullWidth
        >
          <DeleteModal
            //@ts-ignore
            textChildren={modalData?.modalObject?.username}
            actionButton={
              <>
                <FancyDialogActions
                  handleAccept={handleSubmit(onSubmit)}
                  cancelModal={handleCancelModal}
                  textAcceptButton={"Eliminar"}
                />
              </>
            }
          />
        </Dialog>
      )}
    </>
  );
};

export default ManagementInventory;
